import './blocks/gutenberg/utility-bar/utility-bar.js';
import './blocks/gutenberg/smart-questions-listing/smart-questions-listing.js';
import './blocks/gutenberg/simple-schedule/simple-schedule.js';
import './blocks/gutenberg/main-header/main-header.js';
import './blocks/global/js/global.js';
import './blocks/global/js/attraction-status.js';
import './blocks/components/tile/tile.js';
import './blocks/components/smart-question-typeahead/smart-question-typeahead.js';
import './blocks/gutenberg/simple-schedule/app/app.js';
import './blocks/gutenberg/main-header/scheduled-notifications/scheduled-notifications.js';
import './blocks/gutenberg/daily-events-listing/app/app.js';
